import React from "react";
import { FaFacebookF, FaInstagram, FaYoutube, FaXTwitter, FaLinkedinIn, FaWhatsapp } from "react-icons/fa6";
import { Helmet } from "react-helmet";
import "./StickySocialMedia.css";

const StickySocialMedia = () => {
  return (
    <>
      {/* Helmet for SEO meta */}
      <Helmet>
        <title>Columbiaa Hospital | Kasturi Nagar, Bengaluru</title>
        <meta
          name="description"
          content="Columbiaa Hospital, Kasturi Nagar, Bengaluru – Follow us on Instagram, Facebook, YouTube, Twitter, and WhatsApp for appointments, health updates, and patient care. Best neurosurgeon, multispeciality hospital, patient care, emergency services, healthcare in Bangalore."
        />
        <meta
          name="keywords"
          content="Columbiaa Hospital, Kasturi Nagar Bengaluru, best hospital in Bengaluru, neurosurgeon Bengaluru, multispeciality hospital Bengaluru, emergency care Bangalore, patient care hospital, brain surgery, medical care, hospital appointments, healthcare Bengaluru, wellness, hospital services"
        />
        {/* Open Graph for Social Sharing */}
        <meta property="og:title" content="Columbiaa Hospital | Kasturi Nagar, Bengaluru" />
        <meta
          property="og:description"
          content="Leading Multispeciality Hospital in Kasturi Nagar, Bengaluru. Book appointments and stay connected with us. Expert doctors, advanced facilities, and patient-focused care."
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:url" content="https://columbiaahospital.com" />
        <meta property="og:locale" content="en_IN" />
        {/* Structured Data for Hospital */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Hospital",
            "name": "Columbiaa Hospital",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Kasturi Nagar",
              "addressLocality": "Bengaluru",
              "addressRegion": "Karnataka",
              "postalCode": "560043",
              "addressCountry": "IN"
            },
            "telephone": "+91 8548979899",
            "url": "https://columbiaahospital.com",
            "sameAs": [
              "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
              "https://www.instagram.com/columbiaahospital/",
              "https://www.facebook.com/columbiaahospital",
              "https://www.youtube.com/@columbiaahospital",
              "https://x.com/columbiaahosp",
              "https://wa.me/918548979899"
            ]
          }
          `}
        </script>
      </Helmet>

      {/* Social Media Group */}
      <div className="sticky-social-media">
        <a
          href="https://www.instagram.com/columbiaahospital/"
          target="_blank"
          rel="noopener noreferrer"
          title="Follow Columbiaa Hospital on Instagram"
          aria-label="Columbiaa Hospital Instagram profile"
        >
          <FaInstagram />
        </a>
        <a
          href="https://www.facebook.com/columbiaahospital"
          target="_blank"
          rel="noopener noreferrer"
          title="Follow Columbiaa Hospital on Facebook"
          aria-label="Columbiaa Hospital Facebook page"
        >
          <FaFacebookF />
        </a>
        <a
          href="https://www.youtube.com/@columbiaahospital"
          target="_blank"
          rel="noopener noreferrer"
          title="Subscribe to Columbiaa Hospital on YouTube"
          aria-label="Columbiaa Hospital YouTube Channel"
        >
          <FaYoutube />
        </a>
        <a
          href="https://x.com/columbiaahosp"
          target="_blank"
          rel="noopener noreferrer"
          title="Follow Columbiaa Hospital on Twitter (X)"
          aria-label="Columbiaa Hospital Twitter profile"
        >
          <FaXTwitter />
        </a>
        <a
          href="https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/"
          target="_blank"
          rel="noopener noreferrer"
          title="Follow Columbiaa Hospital on LinkedIn"
          aria-label="Columbiaa Hospital LinkedIn page"
        >
          <FaLinkedinIn />
        </a>
      </div>

      {/* WhatsApp Separate */}
      <div className="sticky-whatsapp">
        <a
          href="https://wa.me/918548979899"
          target="_blank"
          rel="noopener noreferrer"
          title="Chat with Columbiaa Hospital on WhatsApp"
          aria-label="Columbiaa Hospital WhatsApp Chat"
        >
          <FaWhatsapp /> 
        </a>
      </div>
    </>
  );
};

export default StickySocialMedia;
